import axios from 'axios'
import config from '@/config/env'

// API configuration for catalogs
const BASE_URL_CATALOGS = config.API_CATALOGS_BASE_URL
const CATALOGS_TOKEN = config.API_CATALOGS_TOKEN

export const apiCatalogs = axios.create({
  baseURL: BASE_URL_CATALOGS,
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json',
  },
})

// Interceptor for adding catalogs token
apiCatalogs.interceptors.request.use(
  (config) => {
    if (CATALOGS_TOKEN) {
      config.headers.Authorization = `Bearer ${CATALOGS_TOKEN}`
    }
    return config
  },
  (error) => {
    return Promise.reject(error)
  },
)

// Interceptor for response handling
apiCatalogs.interceptors.response.use(
  (response) => {
    return response
  },
  (error) => {
    return Promise.reject(error)
  },
)
